<ngx-ui-loader 
  [fgsColor]="'#F4A95C'" 
  [pbColor]="'#F4A95C'"
 
  [fgsSize]="60">
</ngx-ui-loader>

<router-outlet></router-outlet>